import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { Booking } from 'src/app/core/models/booking.model';
import { SessionNote } from 'src/app/core/models/session-note.model';
import { BookingsService } from 'src/app/core/services/bookings.service';
import { SessionNotesService } from 'src/app/core/services/session-notes.service';
import { MatDialog } from '@angular/material/dialog';
import { WriteInstructorNotesComponent } from '../write-instructor-notes/write-instructor-notes.component';
import { AuthService } from 'src/app/core/services/auth.service';
import { InstructorNotesComponent } from '../instructor-notes/instructor-notes.component';
import * as moment from 'moment-timezone';
@Component({
  selector: 'app-instructor-notes-list',
  templateUrl: './instructor-notes-list.component.html',
  styleUrls: ['./instructor-notes-list.component.sass']
})
export class InstructorNotesListComponent implements OnInit, OnChanges {
  @Input()
  instructorId: string;
  @Input()
  studentId: string;
  @Input()
  noCard:boolean = false;
  noNotes: boolean;
  bookings: Booking[];
  sessionNotes: SessionNote[];

  constructor(private bookingsService: BookingsService, public dialog: MatDialog, private authService: AuthService) {
    this.noNotes = true;
  }

  ngOnInit(): void {
    this.authService.currentUser.subscribe(async data => {
      if(data.userId==this.instructorId && this.studentId) {
         this.bookingsService.getStudentBookingsForInstructor(this.instructorId, this.studentId).subscribe(bookings=>{
         this.bookings=bookings;
        });

      } else  if (this.studentId) {
       (await this.bookingsService.getBookingsForStudent(this.studentId, 10)).subscribe(bookings=>{
        if (bookings && bookings.length !== 0) {
          this.bookings=bookings;
        }
       });

      } else if (this.instructorId) {
        const endDate = moment().add(1, 'day').toDate();
        const startDate = moment().subtract(1, 'month').toDate();
        this.bookingsService.getInstructorDates(this.instructorId, startDate, endDate).subscribe(bookings=>{
          if (bookings && bookings.length !== 0) {
            this.noNotes = false;
            this.bookings = bookings;
          } else {
            this.noNotes = true;
          }
        });

      }

    });
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {

  }

  logNotes(booking: Booking) {
    const dialogRef = this.dialog.open(WriteInstructorNotesComponent, {
      data: {
        booking: booking
      }
    });
  }

  viewNotes(booking: Booking) {
    const dialogRef = this.dialog.open(InstructorNotesComponent, {
      data: {
        booking: booking
      }
    });
  }
}
